// src/Button/Button.tsx
import Button from "@mui/material/Button";
import { jsx } from "react/jsx-runtime";
function MUISButton({ ...props }) {
  return /* @__PURE__ */ jsx(Button, { ...props });
}
export {
  MUISButton
};
